import { post } from '../request';
import { BASE } from './config';

/**
 * 微信 JS-SDK、开放标签相关后端接口
 */
export const WechatApi = {
  /**
   * 获取当前页面对应的 JS-SDK 签名配置（用于 wx.config）
   * 请求体：`{ url }`。未传参时使用 `window.location.href`。
   * @param {string} [url] 可选，覆盖请求体里的页面地址（如单测）；默认 `location.href`
   * @returns {Promise<object>}
   */
  fetchJsSdkSignature(url) {
    const pageUrl =
      url != null && String(url).trim() !== ''
        ? String(url)
        : typeof window !== 'undefined' && window.location
          ? window.location.href
          : '';
    return post(
      `${BASE}/third/wechat/sign/js-sdk`,
      { url: pageUrl },
      { baseURL: '', withAuth: true }
    );
  },
};
